<template>
  <div class="d-flex flex-column" style="height:100vh;">
    <appNav v-if="isDev"></appNav>
    <b-container class="mb-5" id="main-container">
      <router-view></router-view>
    </b-container>
  </div>
</template>

<script>
import appNav from './shared/components/header'
export default {
  components: { appNav },
  data () {
    return {
      isDev: process.env.NODE_ENV !== 'production'
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
